module.exports = __webpack_public_path__ + "img/item12.55a4af86.png";